'use client';
import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import MetricsBentoGrid from './components/MetricsBentoGrid';
import WatchlistPanel from './components/WatchlistPanel';
import AISignalsPanel from './components/AISignalsPanel';
import SectorHeatmap from './components/SectorHeatmap';
import TopMoversTable from './components/TopMoversTable';
import NiftyChartSection from './components/NiftyChartSection';

export default function MarketDashboardPage() {
  const [selectedIndex, setSelectedIndex] = useState('NIFTY 50');

  return (
    <AppLayout activePath="/market-dashboard">
      <div className="space-y-3 lg:space-y-5">
        <MetricsBentoGrid selectedIndex={selectedIndex} onIndexSelect={setSelectedIndex} />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-3 lg:gap-5">
          <div className="xl:col-span-2">
            <NiftyChartSection selectedIndex={selectedIndex} />
          </div>
          <div>
            <AISignalsPanel />
          </div>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-3 lg:gap-5">
          <div className="xl:col-span-2">
            <WatchlistPanel />
          </div>
          <div>
            <SectorHeatmap />
          </div>
        </div>
        <TopMoversTable />
      </div>
    </AppLayout>
  );
}